import React from "react";

import Popover from "@material-ui/core/Popover";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { BottomSheet } from "shared/ui/BottomSheet";

import { Divider, Hint, List, Row, SheetList, Text } from "./styles";

export interface ActionMenuItem {
    key: string;
    label: string;
    hint?: string;
    icon?: React.ReactNode;
    tone?: "default" | "danger";
    disabled?: boolean;
    // Разделитель ПЕРЕД пунктом — им отбивается опасное действие от остальных.
    separated?: boolean;
    onClick: () => void;
}

interface ActionMenuProps {
    open: boolean;
    onClose: () => void;
    items: ActionMenuItem[];
    // Якорь нужен только на широком вьюпорте; на узком меню открывается нижним листом.
    anchorEl: HTMLElement | null;
    title?: string;
}

/*
* Меню действий над одним объектом. На десктопе — поповер у кнопки «⋯», на узком экране —
* нижний лист: попадать в мелкие пункты поповера пальцем неудобно, и так же ведут себя
* остальные поповеры этого экрана.
* */
export const ActionMenu = ({ open, onClose, items, anchorEl, title }: ActionMenuProps) => {
    const theme = useTheme();
    const isWide = useMediaQuery(theme.breakpoints.up("sm"));

    const renderRows = (inSheet: boolean) =>
        items.map((item) => (
            <React.Fragment key={item.key}>
                {item.separated && <Divider />}
                <Row
                    type="button"
                    disabled={item.disabled}
                    $tone={item.tone || "default"}
                    $inSheet={inSheet}
                    onClick={() => {
                        onClose();
                        item.onClick();
                    }}
                >
                    {item.icon}
                    <Text>
                        {item.label}
                        {item.hint && <Hint>{item.hint}</Hint>}
                    </Text>
                </Row>
            </React.Fragment>
        ));

    if (!isWide) {
        return (
            <BottomSheet open={open} title={title} onClose={onClose}>
                <SheetList>{renderRows(true)}</SheetList>
            </BottomSheet>
        );
    }

    return (
        <Popover
            open={open && !!anchorEl}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <List>{renderRows(false)}</List>
        </Popover>
    );
};
